import { Language, OrderPageData, VoucherSoldTypes } from '../../api';

export const sellsBothVoucherTypes = (orderPage: OrderPageData | null | undefined): boolean =>
  orderPage?.effective_vouchers_config?.sold_types === VoucherSoldTypes.BOTH;

export const sellsMonetaryVouchers = (orderPage: OrderPageData | null | undefined): boolean =>
  orderPage?.effective_vouchers_config?.sold_types === VoucherSoldTypes.MONETARY || sellsBothVoucherTypes(orderPage);

/**
 * Check if disclaimers step should be shown
 * Shows if disclaimers exist for the current language and has content
 */
export const shouldShowDisclaimersStep = (orderPage: OrderPageData | null | undefined, language: Language): boolean => {
  const disclaimers = orderPage?.disclaimers;
  if (!disclaimers || !disclaimers[language]) {
    return false;
  }

  // Check if disclaimers content exists and is not empty (excluding HTML tags)
  const content = disclaimers[language];
  if (!content) {
    return false;
  }

  // Remove HTML tags and check if there's actual content
  const textContent = content.replace(/<[^>]*>/g, '').trim();
  return textContent.length > 0;
};
